




































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { dispatchGetGetContactTasks } from '@/store/main/actions';
import { IContactTasksRow } from '@/interfaces';

@Component({
  components: {
    FmvAvatar,
    // MdIcon,
  },
})
export default class ContactTasksModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: true, default: null}) readonly public lead: any;
  public tasksList: IContactTasksRow[] = [];
  public loadingState = {
    page: true,
    submit: false,
  };

  public async mounted() {
    if (this.lead) {
      this.tasksList = await dispatchGetGetContactTasks(this.$store, {user_id: this.lead.pk});
    } else {
      this.closeModal();
    }
    this.loadingState.page = false;
  }

  public closeModal() {
    this.$emit('close-modal');
  }
  
  get userProfile() {
    return readUserProfile(this.$store);
  }

}
